/* ============================================================
   Analuisa Replica - Theme JavaScript v2
   Vanilla JS, no dependencies
   ============================================================ */

(function () {
  'use strict';

  /* ---- Sticky header shadow on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile menu toggle ---- */
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav = document.getElementById('MobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
      document.body.classList.toggle('nav-open', !expanded);
    });
  }

  /* ---- Cart dropdown toggle ---- */
  var cartWrapper = document.querySelector('[data-cart-wrapper]');
  var cartDropdown = document.querySelector('[data-cart-dropdown]');
  if (cartWrapper && cartDropdown) {
    var cartIcon = cartWrapper.querySelector('.site-header__cart');
    var isCartHover = false;

    cartWrapper.addEventListener('mouseenter', function () {
      isCartHover = true;
      cartDropdown.hidden = false;
    });

    cartWrapper.addEventListener('mouseleave', function () {
      isCartHover = false;
      setTimeout(function () {
        if (!isCartHover) cartDropdown.hidden = true;
      }, 200);
    });

    // Click on mobile
    cartIcon.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        cartDropdown.hidden = !cartDropdown.hidden;
      }
    });
  }

  /* ---- Announcement bar countdown timer ---- */
  var countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    var endTime = countdownEl.dataset.countdownEnd || '';
    var timeDisplay = countdownEl.querySelector('[data-countdown-time]');

    if (!endTime) {
      endTime = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();
    }

    var endDate = new Date(endTime).getTime();

    if (isNaN(endDate)) {
      endDate = Date.now() + 24 * 60 * 60 * 1000;
    }

    var updateCountdown = function () {
      var now = Date.now();
      var diff = endDate - now;

      if (diff <= 0) {
        if (timeDisplay) timeDisplay.textContent = '00h : 00m : 00s';
        return;
      }

      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (timeDisplay) {
        timeDisplay.textContent =
          String(hours).padStart(2, '0') + 'h : ' +
          String(minutes).padStart(2, '0') + 'm : ' +
          String(seconds).padStart(2, '0') + 's';
      }
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ---- Filter toggle (collection) ---- */
  var filterToggle = document.querySelector('.filter-toggle');
  var filterPanel = document.getElementById('CollectionFilters');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var expanded = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', String(!expanded));
      filterPanel.hidden = expanded;
    });
  }

  /* ---- Product Gallery: thumbnail switching ---- */
  var thumbs = document.querySelectorAll('.product-media__thumb');
  var mainItems = document.querySelectorAll('.product-media__main-item');
  if (thumbs.length > 0 && mainItems.length > 0) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.dataset.mediaId;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        mainItems.forEach(function (item) {
          item.classList.toggle('is-active', item.dataset.mediaId === mediaId);
        });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Product: Quantity + / - ---- */
  var qtyPlus = document.querySelector('[data-quantity-plus]');
  var qtyMinus = document.querySelector('[data-quantity-minus]');
  var qtyInput = document.querySelector('.quantity-input__field');
  if (qtyInput) {
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
        qtyInput.dispatchEvent(new Event('change'));
      });
    }
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value || '1', 10);
        if (v > 1) {
          qtyInput.value = v - 1;
          qtyInput.dispatchEvent(new Event('change'));
        }
      });
    }
  }

  /* ---- Product: Variant selection via option buttons ---- */
  var variantDataEl = document.querySelector('[data-variant-data]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var productForm = document.getElementById('AddToCartForm');

  if (variantDataEl && variantIdInput && productForm) {
    var variants = [];
    try {
      variants = JSON.parse('[' + variantDataEl.textContent.trim() + ']');
    } catch (e) {
      try {
        variants = JSON.parse(variantDataEl.textContent.trim());
      } catch (e2) {
        variants = [];
      }
    }

    var optionGroups = document.querySelectorAll('.product-form__option');
    var selectedOptions = [];

    var currentId = variantIdInput.value;
    var currentVariant = variants.find(function (v) { return String(v.id) === String(currentId); });
    if (currentVariant && currentVariant.options) {
      selectedOptions = currentVariant.options.slice();
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return String(opt) === String(selectedOptions[i]);
        });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        var submitBtn = productForm.querySelector('[data-add-to-cart]');
        var submitText = productForm.querySelector('[data-add-to-cart-text]');
        var stockEl = document.querySelector('[data-stock-status]');
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = window.themeStrings ? themeStrings.unavailable : 'Unavailable';
        if (stockEl) {
          stockEl.className = 'product-form__stock is-out-of-stock';
          stockEl.textContent = 'Unavailable';
        }
        return;
      }

      variantIdInput.value = variant.id;

      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var submitText = productForm.querySelector('[data-add-to-cart-text]');
      var stockEl = document.querySelector('[data-stock-status]');

      if (variant.available) {
        if (submitBtn) submitBtn.disabled = false;
        if (submitText) submitText.textContent = window.themeStrings ? themeStrings.addToCart : 'Add to cart';
        if (stockEl) {
          stockEl.className = 'product-form__stock is-in-stock';
          stockEl.textContent = window.themeStrings ? themeStrings.inStock : 'In stock';
        }
      } else {
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = window.themeStrings ? themeStrings.soldOut : 'Sold out';
        if (stockEl) {
          stockEl.className = 'product-form__stock is-out-of-stock';
          stockEl.textContent = window.themeStrings ? themeStrings.soldOut : 'Sold out';
        }
      }

      var priceContainer = document.getElementById('ProductPriceContainer');
      if (priceContainer && variant.price_formatted) {
        var priceHtml = '<span class="price__regular">' + variant.price_formatted + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var cmp = variant.compare_at_price;
          var compareFormatted = '$' + (cmp / 100).toFixed(2);
          priceHtml = '<span class="price__was">' + compareFormatted + '</span> ' + priceHtml;
        }
        priceContainer.innerHTML = priceHtml;
      }

      optionGroups.forEach(function (group, i) {
        var valueSpan = group.querySelector('[data-option-value]');
        if (valueSpan && selectedOptions[i] !== undefined) {
          valueSpan.textContent = selectedOptions[i];
        }
      });
    }

    optionGroups.forEach(function (group, optionIndex) {
      var btns = group.querySelectorAll('.product-form__option-btn');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selectedOptions[optionIndex] = btn.dataset.value;
          updateUI();
        });
      });
    });

    productForm.addEventListener('submit', function (e) {
      var variant = findVariant();
      if (!variant || !variant.available) {
        e.preventDefault();
      }
    });
  }

  /* ---- Accordion ---- */
  var accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
  accordionToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var body = toggle.nextElementSibling;
      var icon = toggle.querySelector('.product-accordion__icon');
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (body) body.hidden = expanded;
      if (icon) icon.textContent = expanded ? '+' : '-';
    });
  });

  /* ---- Reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .collection-list__item, .brand-statement__inner').forEach(function (el) {
      el.classList.add('reveal-on-scroll');
      observer.observe(el);
    });
  }

  /* ---- Featured collection carousels ---- */
  document.querySelectorAll('[data-section-type="featured-carousel"]').forEach(function (section) {
    var viewport = section.querySelector('[data-product-carousel]');
    var track = section.querySelector('.featured-collection__track');
    var slides = section.querySelectorAll('.featured-collection__slide');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    var index = 0;

    if (!viewport || !track || !slides.length) return;

    function metrics() {
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      var visible = Math.max(1, Math.floor((viewport.clientWidth + gap) / (slideWidth + gap)));
      return { step: slideWidth + gap, max: Math.max(0, slides.length - visible) };
    }

    function updateCarousel() {
      var values = metrics();
      index = Math.min(index, values.max);
      track.style.transform = 'translate3d(' + (-index * values.step) + 'px,0,0)';
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= values.max;
    }

    if (prev) prev.addEventListener('click', function () { index = Math.max(0, index - 1); updateCarousel(); });
    if (next) next.addEventListener('click', function () { index = Math.min(metrics().max, index + 1); updateCarousel(); });
    window.addEventListener('resize', updateCarousel, { passive: true });
    updateCarousel();
  });

  /* ---- Touch once to reveal quick add; tap again to open product ---- */
  document.querySelectorAll('[data-product-card-link]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!window.matchMedia('(hover: none)').matches) return;
      var card = link.closest('[data-product-card]');
      if (!card || !card.classList.contains('product-card--quick-add')) return;
      if (!card.classList.contains('is-quick-add-open')) {
        event.preventDefault();
        document.querySelectorAll('.product-card.is-quick-add-open').forEach(function (openCard) {
          openCard.classList.remove('is-quick-add-open');
        });
        card.classList.add('is-quick-add-open');
      }
    });
  });

  /* ---- Theme strings ---- */
  var themeStrings = {
    addToCart: 'Add to cart',
    soldOut: 'Sold out',
    unavailable: 'Unavailable',
    inStock: 'In stock'
  };
  window.themeStrings = themeStrings;
})();
